const LOCAL_STORAGE_COMPARE_KEY = 'shopify-compare';
const LOCAL_COMPARE_STORAGE_DELIMITER = ',';
const BUTTON_COMPARE_ACTIVE_CLASS = 'active';
const GRID_COMPARE_LOADED_CLASS = 'loaded';

const compareSelectors = {
  button: '[button-compare]',
  grid: '[grid-compare]',
  productCard: '.product-card-compare',
};

// Toast notification system
const showCompareToast = (message, showLink = false) => {
  const existingToast = document.querySelector('.compare-toast');
  if (existingToast) existingToast.remove();

  const toast = document.createElement('div');
  toast.className = 'compare-toast';

  const comparePageUrl = document.querySelector('[data-compare-url]')?.dataset.compareUrl || '/pages/compare';
  const linkHtml = showLink ? `<a href="${comparePageUrl}" class="compare-toast__link">View compare list</a>` : '';

  toast.innerHTML = `
    <span class="compare-toast__message">${message}</span>
    ${linkHtml}
  `;

  if (!document.querySelector('#compare-toast-styles')) {
    const styles = document.createElement('style');
    styles.id = 'compare-toast-styles';
    styles.textContent = `
      .compare-toast {
        position: fixed;
        top: 20px;
        right: 20px;
        background: #fff;
        border: 1px solid var(--color-base-border, #e5e5e5);
        padding: 12px 20px;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        z-index: 99999;
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 12px;
        animation: compareToastIn 0.3s ease, compareToastOut 0.3s ease 4.7s forwards;
      }
      .compare-toast__message {
        color: var(--color-body-text, #333);
      }
      .compare-toast__link {
        color: var(--color-base-accent-1, #000);
        text-decoration: underline;
        font-weight: 500;
        white-space: nowrap;
      }
      .compare-toast__link:hover {
        opacity: 0.7;
      }
      @keyframes compareToastIn {
        from { opacity: 0; transform: translateX(100%); }
        to { opacity: 1; transform: translateX(0); }
      }
      @keyframes compareToastOut {
        from { opacity: 1; transform: translateX(0); }
        to { opacity: 0; transform: translateX(100%); }
      }
      @media (max-width: 480px) {
        .compare-toast {
          left: 20px;
          right: 20px;
          top: auto;
          bottom: 20px;
        }
      }
    `;
    document.head.appendChild(styles);
  }

  document.body.appendChild(toast);
  setTimeout(() => toast.remove(), 5000);
};

document.addEventListener('DOMContentLoaded', () => {
  initButtonsCompare();
  initGridCompare();
});

document.addEventListener('shopify-compare:updated', (event) => {
  console.log('[Shopify Compare] Compare Updated ✅', event.detail.compare);
  initGridCompare();
});

document.addEventListener('shopify-compare:init-product-grid', (event) => {
  console.log('[Shopify Compare] Compare Product List Loaded ✅', event.detail.compare);
});

document.addEventListener('shopify-compare:init-buttons', (event) => {
  console.log('[Shopify Compare] Compare Buttons Loaded ✅', event.detail.compare);
});

const fetchCompareProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(compareSelectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Compare] Failed to load content for handle: ${handle}`, err));
};

const setupGridCompare = async (grid) => {
  const compare = getCompare();
  const requests = compare.map(fetchCompareProductCardHTML);
  const responses = await Promise.all(requests);
  const compareProductCards = responses.join('');
  grid.innerHTML = compareProductCards;
  grid.classList.add(GRID_COMPARE_LOADED_CLASS);
  initButtonsCompare();

  const event = new CustomEvent('shopify-compare:init-product-grid', {
    detail: { compare: compare }
  });
  document.dispatchEvent(event);
};

const setupCompareButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Compare] Missing `data-product-handle` attribute. Failed to update the compare.');
    if (compareContains(productHandle)) button.classList.add(BUTTON_COMPARE_ACTIVE_CLASS);
    button.addEventListener('click', () => {
      const isInCompare = compareContains(productHandle);
      updateCompare(productHandle);
      button.classList.toggle(BUTTON_COMPARE_ACTIVE_CLASS);

      if (isInCompare) {
        showCompareToast('Removed from compare', false);
      } else {
        showCompareToast('Added to compare', true);
      }
    });
  });
};

/*const compNotification = () => {
  $('.postNotification, .postNotification1').fadeIn("fast").delay(2000).fadeOut("fast");
  if ($("button[button-compare]").hasClass("active")){
    $(".postNotification").show();  
    $(".postNotification1").hide();  
  } else {
    $(".postNotification1").show();  
    $(".postNotification").hide();  
  }
};*/

const initGridCompare = () => {
  const grid = document.querySelector(compareSelectors.grid) || false;
  if (grid) setupGridCompare(grid);
};

const initButtonsCompare = () => {
  const buttons = document.querySelectorAll(compareSelectors.button) || [];
  if (buttons.length) setupCompareButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-compare:init-buttons', {
    detail: { compare: getCompare() }
  });
  document.dispatchEvent(event);
};

const getCompare = () => {
  const compare = localStorage.getItem(LOCAL_STORAGE_COMPARE_KEY) || false;
  if (compare) return compare.split(LOCAL_COMPARE_STORAGE_DELIMITER);
  return [];
};

const setCompare = (array) => {
  const compare = array.join(LOCAL_COMPARE_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_COMPARE_KEY, compare);
  else localStorage.removeItem(LOCAL_STORAGE_COMPARE_KEY);

  const event = new CustomEvent('shopify-compare:updated', {
    detail: { compare: array }
  });
  updateCompareCount();    
  document.dispatchEvent(event);

  return compare;
};

const updateCompare = (handle) => {
  const compare = getCompare();
  const indexInCompare = compare.indexOf(handle);
  if (indexInCompare === -1) compare.push(handle);
  else compare.splice(indexInCompare, 1);
  return setCompare(compare);
};

const compareContains = (handle) => {
  const compare = getCompare();
  return compare.includes(handle);
};

const resetCompare = () => {
  return setCompare([]);
};

const updateCompareCount = () => {
    const compare = getCompare();       
    $('[data-js-compare-count]').attr('data-js-compare-count', compare.length).html(compare.length);     
    if (compare.length === 0) {
      $(".comp-info").css("display", "block");
      $(".cm-compare-button").css("display", "none");
    } else {
      $(".comp-info").css("display", "none");
      $(".cm-compare-button").css("display", "");
    }
};

$(document).ready(function() {
  updateCompareCount();
})
